module.exports = __webpack_public_path__ + "img/rating_emojis.b3fe9ac.jpg";